export default __webpack_public_path__ + "static/media/aurora-perrineau-aaron-paul.6e2ba663.jpg";